<template>
  <div class="section section-white">
    <el-form ref="form" :model="form" label-position="left" label-width="120px">
      <div class="section-body">
        <template>
          <el-form-item label="订单自动取消:">
              未付款订单，将在 <el-input type="number" required min="1" v-model="form.order_cancel_time" placeholder="" style="width: 100px;" />(分钟)之后取消
          </el-form-item>
          <el-form-item label="订单自动确认:">
              已发货订单，将在 <el-input type="number" required min="0" v-model="form.order_finish_time" placeholder="" style="width: 100px;" /> (天)后自动完成
          </el-form-item>
        </template>
      </div>
      <div class="section-footer with-border content-center">
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import { getOrderSetting, setOrderSetting } from '@/api/trade'
  export default {
    data () {
      return {
          form: {
            order_cancel_time: 15,
            order_finish_time: 7,
          },
      }
    },
    methods: {
      save() {
        console.log(this.form)
        setOrderSetting(this.form).then(res => {
            this.$message({message: '保存成功', type: 'success'})
        })
      }
    },
    mounted () {
      getOrderSetting().then(res => {
        let setting = res.data.data
        if (setting.order_cancel_time) {
          this.form.order_cancel_time = setting.order_cancel_time
        }
        if (setting.order_finish_time) {
          this.form.order_finish_time = setting.order_finish_time
        }
      })
    }
  }
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// ordersetting.vue?1e67c531